import { render, staticRenderFns } from "./StockTable.vue?vue&type=template&id=7811504d&"
import script from "./StockTable.vue?vue&type=script&lang=ts&"
export * from "./StockTable.vue?vue&type=script&lang=ts&"
import style0 from "./StockTable.vue?vue&type=style&index=0&id=7811504d&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports